export default {
    methods: {
        options_filtered_selected(serviceId) {
            return this.$store.state.options.filter(function(item) {
                return item.services_id === serviceId && item.selected;
            })
        },
    }
    
}